import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals, text } from 'src/theme/colors';

export const styles = StyleSheet.create({
  icon: {
    width: 32,
    height: 32,
    borderRadius: 21,
    justifyContent: 'center',
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      color: '#000000',
      opacity: 0.05,
    }),
    backgroundColor: neutrals.white,
  },
  iconAction: {
    width: 14,
    height: 14,
  },
  countText: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 14,
    color: text.color.interactive,
    minWidth: 16,
    textAlign: 'center',
    padding: 4,
  },
  countTextFocused: {
    borderWidth: 1,
    borderColor: FOCUS_COLOR,
    backgroundColor: neutrals.white,
    borderRadius: 4,
  },
});
